var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShiftNote = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m19.675 20.375.7-.7L18.5 17.8V15h-1v3.2zM5 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 19V5q0-.824.587-1.412A1.93 1.93 0 0 1 5 3h14q.824 0 1.413.587Q21 4.176 21 5v6.7a8 8 0 0 0-.975-.387A6 6 0 0 0 19 11.075V5H5v14h6.05q.076.55.237 1.05.163.5.388.95zm0-3v1V5v6.075V11zm2-1h4.075q.076-.525.238-1.025t.362-.975H7zm0-4h6.1q.8-.75 1.787-1.25A7 7 0 0 1 17 11.075V11H7zm0-4h10V7H7zm11 14q-2.075 0-3.537-1.462Q13 20.074 13 18q0-2.075 1.463-3.537Q15.926 13 18 13q2.075 0 3.538 1.463T23 18t-1.462 3.538Q20.074 23 18 23"
})));
export default SvgShiftNote;